<template>
  <!-- 试听 -->
  <div class="audition-page new-user">
    <div
      class="video-player"
      :class="{ 'is-full-screen': isFullScreen }"
      style="position: relative"
    >
      <div class="sharebtn" v-show="!isFullScreen && showTitle">
        <div v-if="!$root.$data.isApp">
          <img class="back" @click="back" src="@/assets/img/newUser/back.png" alt="" />
          <p>{{ headerTitle }}</p>
        </div>
        <img class="share" @click="copy()" src="@/assets/img/newUser/share.png" alt="" />
      </div>
      <div id="player"></div>
      <div class="next-video" v-if="videoEndTool">
        <template>
          <div class="tool-btn">
            <div class="replay-btn" @click="replay">重新播放</div>
          </div>
        </template>
      </div>
    </div>
    <!--  推荐课程-->
    <div class="course" v-if="recommendCourse.length">
      <div class="title">
        <span></span>
        <b>好课推荐</b>
        <span></span>
      </div>
      <HotCourseCard
        v-for="(item, keys) in recommendCourse"
        :key="keys"
        @click.native="setInfo"
        :item="item"
      />
    </div>
    <CommonLoading :loading="loading" />
  </div>
</template>
<script>
import loadJS from 'load-js';
import {copyTool, deepCopy} from '@/utils/tools';
import { RECORD_SITE_ID } from '@/utils/common';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import { reqStatistics, reqAcvitityPrize } from '@/api/newUser';
import { reqProducts } from '@/api/home';
import HotCourseCard from '../../components/hotCourseCard/hotCourseCard.vue';

export default {
  components: {
    CommonLoading,
    HotCourseCard,
  },
  data() {
    return {
      videoEndTool: false,
      headerTitle: '视频标题',
      isFullScreen: false, // 是否是全屏
      player: null,
      loading: false,
      shareUrl: window.location.href,
      showTitle: false,
      recommendCourse: [],
    };
  },

  methods: {
    // 查询23注册活动
    getActity() {
      const { activeId } = this.$route.query;
      reqAcvitityPrize(activeId).then((res) => {
        const { data } = res;
        const { recommendIds } = data;
        this.getCourseDetail(recommendIds, 2);
      });
    },
    setInfo() {
      sessionStorage.setItem('back', true);
    },
    // 根据课程id集合 查询课程信息
    async getCourseDetail(productIds) {
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const { code, data } = await reqProducts(productIds, endPoint);
      if (code === 0 && data) {
        data.forEach((item) => {
          const copyItem = deepCopy(item)
          const { productDiscountRespVO, teacherRespVOS } = item;
          Object.assign(item, {
            salesVolume: Number(item.realSales) + Number(item.initialSales),
            courseBeginTime: item.startTime, // 开课时间
            isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
            isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
            teacherRespVOS: teacherRespVOS?.map((teacher) => ({
              teacherHead: teacher.teacherHead ? teacher.teacherHead : this.defaultImg,
              name: teacher.name,
            })),
          });
          if (
            productDiscountRespVO?.isCouponDiscount
            && productDiscountRespVO?.couponDiscount
            && item.sellPrice > 0
            && !productDiscountRespVO?.promotionLabel
          ) {
            Object.assign(item, {
              promotionLabel: 4,
              originalPrice: item.sellPrice,
              sellPrice: productDiscountRespVO.discountPrice,
            });
          }
          if (productDiscountRespVO?.promotionLabel) {
            Object.assign(item, {
              promotionLabel: productDiscountRespVO?.promotionLabel,
              originalPrice: (Number(productDiscountRespVO.discountMinPrice)
                + Number(productDiscountRespVO.discountAmount)).toFixed(2),
              sellPrice: productDiscountRespVO.discountMinPrice,
              acvitityShowTime: productDiscountRespVO?.promotionShowTime,
              acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
              acvitityEndTime: productDiscountRespVO?.promotionEndTime,
            });
          }
          if (productDiscountRespVO?.isGroupDiscount) {
            Object.assign(item, {
              promotionLabel: 5,
              originalPrice: copyItem.sellPrice,
              sellPrice: productDiscountRespVO.discountMinPrice,
            });
          }
        });

        this.recommendCourse = data;
      }
    },
    async init() {
      this.loading = true;
      this.initData();
    },
    // 重新播放
    replay() {
      this.player.play();
    },
    initData() {
      loadJS([
        {
          async: false,
          url: 'https://p.bokecc.com/player?siteid=096E928BC2A97B87&newversion=true',
        },
      ]).then(() => {
        this.setPlayerCallBack();
      });
    },
    createPlayer() {
      this.playerEle = document.getElementById('player');
      const { vid, cid, vname } = this.$route.query;
      document.title = vname;
      this.headerTitle = vname;
      this.player = window.createCCH5Player({
        vid,
        siteid: RECORD_SITE_ID,
        playtype: 1,
        autoStart: true,
        width: '100%',
        height: '100%',
        open_barrage: false,
        allowFullScreen: false,
        parentNode: this.playerEle,
        isShare: false, // TODO：隐藏分享按钮，目前现在不生效，用CSS强制隐藏了
        vc: cid,
      });
    },
    setPlayerCallBack() {
      if (window.createCCH5Player) {
        this.createPlayer();
      } else {
        window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      }

      window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      window.on_CCH5player_ready = this.onPlayerReady;
      window.on_player_volumechange = this.onPlayerVolumeChange;
      window.on_CCH5player_ended = this.onPlayerEnded;
      window.on_CCH5player_play = this.onPlayerPlay;
      window.on_CCH5player_pause = this.onPlayerPause;
      // window.get_cc_verification_code = this.get_cc_verification_code;
    },

    onCCH5PlayerLoaded() {
      window.ccH5PlayerJsLoaded = true;
      this.createPlayer();
    },

    onPlayerReady() {
      this.loading = false;
      window.cc_js_Player.setVolume(0.3);
      this.player.play();

      document.getElementsByClassName('video-player')[0].onclick = () => {
        this.showTitle = !this.showTitle;
        setTimeout(() => {
          this.showTitle = false;
        }, 10000);
      };
      // 全屏按钮点击
      document.getElementsByClassName('ccH5FullsBtn')[0].onclick = () => {
        this.isFullScreen = !this.isFullScreen;
        if (this.isFullScreen) {
          // 全屏时关闭openApp
          this.$nextTick(() => {
            const winH = window.innerHeight;
            const winW = window.innerWidth;
            const ele = document.getElementsByClassName('is-full-screen')[0];
            ele.style.width = `${winH}px`;
            ele.style.height = `${winW}px`;
            ele.style.transform = `rotate(90deg) translateX(-${winW}px)`;
            ele.style.transformOrigin = 'bottom left';
          });
        } else {
          this.$nextTick(() => {
            const winW = window.innerWidth;
            const ele = document.getElementsByClassName('video-player')[0];
            ele.style.width = `${winW}px`;
            ele.style.height = `${winW * (9 / 16)}px`;
            ele.style.transform = 'rotate(0)';
            ele.style.transformOrigin = 'bottom left';
          });
        }
      };
    },
    // 播放结束时回调
    onPlayerEnded() {
      this.videoEndTool = true;
    },
    // 播放时回调
    onPlayerPlay() {
      this.videoEndTool = false;
    },
    // 暂停播放是回调
    onPlayerPause() {
      // 回调
    },
    onPlayerVolumeChange() {},
    back() {
      window.history.go(-1);
    },
    copy() {
      copyTool(this.shareUrl)
        .then(() => {
          this.$toast('复制成功');
        })
        .catch(() => {
          this.$toast('复制失败');
        });
    },
    openTitle() {
      // alert(333)
      this.showTitle = true;
    },
    updatePalyNum() {
      const { id } = this.$route.query;
      reqStatistics(id);
      // console.log(2222);
    },
  },
  destroyed() {
    // eslint-disable-next-line no-unused-expressions
    this.player && this.player.destroy();
  },
  mounted() {
    this.init();
    this.updatePalyNum();
    this.getActity();
  },
};
</script>

<style scoped lang="scss">
.title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  span {
    display: inline-block;
    width: 84px;
    height: 2px;
    background: #ffe1cc;
  }
  b {
    padding: 0 48px;
    color: #ff6c02;
    font-weight: 500;
    font-size: 32px;
  }
}
.audition-page {
  .empty {
    width: 100%;
    height: 100px;
  }

  .video-player {
    position: relative;

    #player,
    #playbackPlayer {
      display: flex;
      align-items: center;
      height: calc(100vw * (9 / 16));
      background: black;
    }

    .next-video {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: white;
      background: rgba(0, 0, 0, 0.5);

      .video-title {
        padding: 0 20%;
      }

      span {
        margin-bottom: 20px;
        font-size: 26px;
      }

      .tool-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 22px;

        div {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .replay-btn {
          width: 150px;
          height: 50px;
          color: #ff6c02;
          font-size: 26px;
          border: 2px solid #ff6c02;
          border-radius: 23px;
        }

        div:last-child {
          width: 150px;
          height: 50px;
          color: white;
          font-size: 26px;
          background: #ff6c02;
          border: 2px solid #ff6c02;
          border-radius: 23px;
        }

        .next-btn {
          margin-left: 24px;
        }
      }
    }
  }

  .is-full-screen {
    display: flex;
    align-items: center;
    justify-content: center;
    //width: 1106px;
    //height: 600px;
    //margin-top: calc((100vh - (100vw * (16 / 9))) / 2);
    margin-top: 0;
    //height: 100vw;
    background: black;

    #player,
    #playbackPlayer {
      width: 100%;
      height: 100%;
      margin-top: 0;
    }

    .next-video {
      top: 0;
      width: 100%;
      height: 100%;
    }

    .commonTitle {
      display: none;
    }
  }
}
.sharebtn {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 200000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 88px;
  // background: url('../../assets/img/newUser/share.png') no-repeat;
  // background-size: 100%;
  padding: 0 36px 0 10px;
  // background: linear-gradient(to bottom, #aaa, #fff);
  background: rgba(0, 0, 0, 0.5);
  > div {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 94%;
    .back {
      width: 42px;
    }
    p {
      width: 500px;
      // margin:0 0 0 30px;
      color: #fff;
      font-size: 36px;
      text-align: center;
      @extend .ellipsis;
    }
  }
  .share {
    width: 48px;
  }
}
.course {
  padding: 40px;
}
</style>
<style lang="scss">
.audition-page {
  .adrPlayBtn {
    display: none !important;
  }
}
</style>
